import { Component, OnInit } from '@angular/core';
import {ApiService} from "../../../services/api-handlers/api.service";
import {localStorageGet, localStorageSave} from "../../helper/typed-local-storage";

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {

    year = 2024;

    private SHOW_MESSAGE_MIN_MILLIS = 10 * 1000;
    public timeAlwaysVisible: boolean = localStorageGet("SERVER_DELTA_TIME_VISIBLE", "false") === "true";
    constructor(private apiService: ApiService) { }

    ngOnInit(): void {
    }

    public shouldShowTime(): boolean {
        if (this.getServerTimeDeltaMillis() > this.SHOW_MESSAGE_MIN_MILLIS || this.getServerTimeDeltaMillis() < -this.SHOW_MESSAGE_MIN_MILLIS) {
            return true;
        }
        return this.timeAlwaysVisible;
    }

    public toggleTime():void {
        this.timeAlwaysVisible = !this.timeAlwaysVisible;
        localStorageSave("SERVER_DELTA_TIME_VISIBLE", this.timeAlwaysVisible ? "true" : "false");
    }

    getServerTimeDeltaString(): string {
        return (this.getServerTimeDeltaMillis() / 1000).toFixed(1)
    }
    getServerTimeDeltaMillis(): number {
        return this.apiService.timeDeltaMillis;
    }
}
